<template>
  <div>
    <el-row class="hidden-md-and-up" style="margin: 15px">
      <el-collapse id='browse-ss-collapse'>
        <el-collapse-item>
          <template slot="title" style="taxt-aling: center">Species selection pane</template>
          <species-navigation-pane></species-navigation-pane>
        </el-collapse-item>
      </el-collapse>
    </el-row>
    <el-row :gutter="20" style="margin: 0px;">
      <el-col :lg="4" :md="4" :sm="24" class="sidebar hidden-sm-and-down">
        <species-navigation-pane></species-navigation-pane>
      </el-col>
      <el-col :lg="20" :md="20" :sm="24" style="height: 90vh; overflow-y: auto; overflow-x: hidden;">
        <div v-if="info === ''">
          <h2>No Species Selected</h2>
          <el-button style="margin-left: 10px;" plain type="primary" @click="showSpeciesTable = true">Add Species</el-button>
        </div>
        <div v-else>
          <el-row style="margin-top: 20px;">
            <el-col :lg="16" :sm="24">
              <transition appear enter-active-class="animated fadeIn faster"
                leave-active-class="animated fadeOut faster">
                <div v-if="store.settings.showSpeciesInfo">
                  <div style="margin: 10px; font-size: 2rem; font-weight: bold">{{ info.OrgInfo.OrganismName }}</div>
                  <h4 style="margin-top: 0px; color: #999999;">{{ info.OrgInfo.Kingdom }} > {{ info.OrgInfo.Group }} >
                    {{ info.OrgInfo.SubGroup }}</h4>
                </div>
              </transition>
            </el-col>
            <el-col :lg="7" :sm="24" style="padding-top: 20px;">
                <el-popover placement="bottom" trigger="hover" transition="el-zoom-in-top" :open-delay="50">
                  <species-genome-info-card :info="info"></species-genome-info-card>
                  <el-button icon="el-icon-info" plain type="primary" slot="reference"></el-button>
                </el-popover>
                <el-tooltip :content="`Download repeats of ${info.OrgInfo.OrganismName} in TSV format`">
                  <el-button style="margin-left: 10px;" plain type="primary" @click="downloadRepeats" icon="el-icon-download"></el-button>
                </el-tooltip>
                <el-tooltip :content="`Open table view of repeats in a new tab`">
                  <el-button type="primary" @click="openRepeats">Explore Repeats</el-button>
                </el-tooltip>
            </el-col>
          </el-row>
          <el-row :gutter="30">
            <el-col :lg="16" :md="20">
              <div style="display: flex; flex-wrap: wrap; justify-content: space-between">
                <repeat-stat label="# Microsatellites" :stat="info.RepInfo.TotalRepFreq" tooltip="Total number of microsatellites in the genome"></repeat-stat>
                <repeat-stat label="Genome Covered" :stat="info.RepInfo.TotalRepBases | exponentiateBases"
                  background="#dcdcdc" tooltip="Total bases in the genome covered by microsatellites"></repeat-stat>
                <repeat-stat label="Genome Covered" :stat="info.RepInfo.PercentGenomeCovered" tooltip="Percentage of genome covered by microsatellites"></repeat-stat>
                <repeat-stat label="SSRs per Mb Genome" :stat="parseInt(info.RepInfo.RepDensityByFreq)"
                  background="#dcdcdc" tooltip="Average SSRs per MB of the genome"></repeat-stat>
                <repeat-stat label="per Mb Genome" :stat="info.RepInfo.RepDensityByBases | exponentiateBases" tooltip="Average bases covered by microsatellites per MB of Genome">
                </repeat-stat>
              </div>
              <el-row>
                <el-col :lg="8" :md="12" :sm="24">
                <main-plot-pie-distribution :info="info" :index="1" style="flex: 1; margin: 10px;"></main-plot-pie-distribution>
                </el-col>
                <el-col :lg="16" :md="12" :sm="24">
                  <main-plot-bar-frequency :info="info" :index="2" style="flex: 2; margin: 10px;"></main-plot-bar-frequency>
                </el-col>
              </el-row>
            </el-col>
            <el-col :lg="7" :md="16" style="margin-top: 10px">
              <table-longest-repeats :info="info"></table-longest-repeats>
            </el-col>
          </el-row>
          <el-row :gutter="30" style="margin-left: 5px">
            <el-col :lg="13" :md="12" :sm="24">
              <table-repeat-frequency style="margin-top: 10px" :info="info"></table-repeat-frequency>
            </el-col>
            <el-col :lg="10" :md="12" :sm="24">
              <main-plot-line-len-frequency style="margin-top: 10px" :info="info" :index="3"></main-plot-line-len-frequency>
            </el-col>
          </el-row>
          <el-row v-if="info.OrgInfo.Annotation === 'Y'" :gutter="30" style="margin-top: 40px; margin-left: 5px">
            <el-col :lg="8" :md="8" :sm="24"> 
              <main-plot-stack-anno-distribution :info="info" :index="4"></main-plot-stack-anno-distribution>
            </el-col>
            <el-col :lg="8" :md="8" :sm="24">
              <main-plot-area-tss-distribution :info="info" :index="5"></main-plot-area-tss-distribution>
            </el-col>
            <el-col :lg="7" :md="8" :sm="24">
              <main-plot-stack-anno-kmer-distribution :info="info" :index="6"></main-plot-stack-anno-kmer-distribution>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <div>
    </div>
    <el-dialog id="plot-modal" :title="store.modalTitles[modalComponent]" top="3vh" width="95%" :visible.sync="showModal">
      <!-- <div slot="title">Blah blah</div> -->
      <el-row class="hidden-md-and-up" style="margin: 15px">
      <el-collapse id='browse-ss-collapse'>
        <el-collapse-item>
          <template slot="title" style="taxt-aling: center">Species selection pane</template>
          <species-navigation-pane></species-navigation-pane>
        </el-collapse-item>
      </el-collapse>
    </el-row>
      <el-row>
        <el-col :span="4" style="border-right: 1px solid lightgrey;" class="hidden-sm-and-down">
          <species-navigation-pane></species-navigation-pane>
        </el-col>
        <el-col :span="19" :offset="1">
        <component :is="modalComponent"></component>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog top="3vh" width="95%" :visible.sync="showSpeciesTable">
      <species-select></species-select>
    </el-dialog>
  </div>
</template>

<script>
import RepeatStat from '../components/RepeatStat.vue'
import SpeciesSelect from '../components/SpeciesSelect.vue'
import SpeciesNavigationPane from '../components/SpeciesNavigationPane.vue'
import SpeciesInfoCard from '../components/SpeciesInfoCard.vue'
import SpeciesGenomeInfoCard from '../components/SpeciesGenomeInfoCard.vue'

import TableRepeatFrequency from '../components/TableRepeatFrequency.vue'
import TableLongestRepeats from '../components/TableLongestRepeats.vue'

import MainPlotBarFrequency from '../components/MainPlotBarFrequency.vue'
import MainPlotLineLenFrequency from '../components/MainPlotLineLenFrequency.vue'
import MainPlotPieDistribution from '../components/MainPlotPieDistribution.vue'
import MainPlotStackAnnoDistribution from '../components/MainPlotStackAnnoDistribution.vue'
import MainPlotBarRepeatWiseAnno from '../components/MainPlotBarRepeatWiseAnno.vue'
import MainPlotAreaTssDistribution from '../components/MainPlotAreaTssDistribution.vue'
import MainPlotStackAnnoKmerDistribution from '../components/MainPlotStackAnnoKmerDistribution.vue'

import ModalBarFrequency from '../components/ModalBarFrequency.vue'
import ModalLineLenFrequency from '../components/ModalLineLenFrequency.vue'
import ModalPieDistribution from '../components/ModalPieDistribution.vue'
import ModalStackAnnoDistribution from '../components/ModalStackAnnoDistribution.vue'
import ModalAreaTssDistribution from '../components/ModalAreaTssDistribution.vue'
import ModalStackAnnoKmerDistribution from '../components/ModalStackAnnoKmerDistribution.vue'

import { store } from '../scripts/store.js'
import { events } from '../scripts/events.js'

const _ = require('lodash')

export default {
  name: 'Browse',
  components: {
    RepeatStat, SpeciesSelect, SpeciesNavigationPane, SpeciesInfoCard, SpeciesGenomeInfoCard, TableRepeatFrequency, TableLongestRepeats, MainPlotBarFrequency, MainPlotLineLenFrequency, MainPlotPieDistribution, MainPlotStackAnnoDistribution, MainPlotBarRepeatWiseAnno, MainPlotAreaTssDistribution, MainPlotStackAnnoKmerDistribution, ModalBarFrequency, ModalLineLenFrequency, ModalPieDistribution, ModalStackAnnoDistribution, ModalAreaTssDistribution, ModalStackAnnoKmerDistribution
  },
  data () {
    return {
      store: store,
      showSpeciesNavigation: false,
      showModal: false,
      modalComponent: 'ModalBarFrequency',
      showSpeciesTable: false
    }
  },
  created () {
    events.$on('open-modal', this.openModal)
    events.$on('show-species-table', this.handleSpeciesTableOpen)
  },
  computed: {
    info () {
      if (store.species.current === '') {
        return '';
      }
      return _.find(store.info, s => s.OrgInfo.MSDBID === store.species.current)
    }
  },
  methods: {
    getPreviousSpecies: function () {
      const currentIndex = store.species.order.indexOf(store.species.current)
      const newIndex = currentIndex === 0 ? store.species.order.length - 1 : currentIndex - 1
      store.setCurrentSpecies(store.species.order[newIndex], 'GetPrevious Button')
    },

    getNextSpecies: function () {
      const currentIndex = store.species.order.indexOf(store.species.current)
      const newIndex = currentIndex === store.species.order.length - 1 ? 0 : currentIndex + 1
      store.setCurrentSpecies(store.species.order[newIndex], 'GetNext Button')
    },

    openModal: function (type) {
      this.modalComponent = type
      this.showModal = true;
    },

    openRepeats: function () {
      const targetID = this.info.OrgInfo.MSDBID
      window.open(`${store.settings.backendBaseURL}${targetID}`, '_blank')
    },
    
    downloadRepeats: function () {
      const targetID = this.info.OrgInfo.MSDBID
      window.open(`${store.settings.downloadBaseURL}${targetID}_perf.tsv`, '_blank')
    },

    handleSpeciesTableOpen: function () {
      this.showSpeciesTable = true
    }
  },
  filters: {
    allCaps (string) {
      if (!string) {
        return
      }
      return string.toUpperCase()
    },
    exponentiateBases (num) {
      if (!num) {
        return
      }
      let base = parseInt(num)
      if (base < 1000) {
        return `${base}bp`
      } else if (base < 1000000) {
        return `${(base/1000).toFixed(2)} Kb`
      } else if (base < 1000000000) {
        return `${(base/1000000).toFixed(2)} Mb`
      } else {
        return `${(base/1000000000).toFixed(2)} Gb`
      }
    }
  }
}
</script>

<style>
.show-navigation-button {
  top:30%;
  position: fixed;
  z-index: 3001;
  left: 0;
  border-left: 0px !important;
  font-size: 20px !important;
  color: #324157 !important;
  padding: 10px 15px !important;
}

.show-navigation-button.inactive {
  left: 0;
  transition: 0.5s;
}

.show-navigation-button.active {
  left: 499px;
  transition: 0.5s;
}

div.el-card__header {
  background-color: #EEF1F6 !important;
  padding: 12px 12px !important;
}

.sidebar {
  border-right: 1px solid lightgrey;
  height: 90vh;
}

#plot-modal .el-dialog__header {
  background-color: #EEF1F6;
  padding-top: 20px;
  padding-bottom: 20px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

#plot-modal .el-dialog {
  border-radius: 10px;
}

#browse-ss-collapse > .el-collapse-item > div > div[role="button"] {
  /* border-width: 1px;
  border-style: solid;
  border-color: #cccccc;
  border-radius: 10px; */
  font-weight: bold;
  font-size: 1em;
  background-color: #EEF1F6;
  padding-left: 15px;
  border-radius: 5px;
  border: 1px solid #B3CDE0;
}

#browse-collapse {
  border: none !important;
  border-radius: 10px;
}
</style>
